// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9l-0";
export var optionCard = "_9l-1";